import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes$1 from 'prop-types';
import React, { useMemo } from 'react';
import { PropTypes } from '@panneau/core';
import { useActionsComponentsManager } from '@panneau/core/contexts';
import Button from '@panneau/element-button';

var _excluded = ["id", "component", "multiple", "withConfirmation"];
var propTypes = {
  resource: PropTypes.resource,
  actions: PropTypes.filters,
  value: PropTypes$1.arrayOf(PropTypes$1.shape({
    id: PropTypes$1.string
  })),
  onChange: PropTypes$1.func,
  onConfirmed: PropTypes$1.func,
  defaultComponent: PropTypes$1.func,
  isGroup: PropTypes$1.bool,
  size: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  withConfirmation: PropTypes$1.bool,
  className: PropTypes$1.string
};
var defaultProps = {
  resource: null,
  actions: [],
  value: null,
  onChange: null,
  onConfirmed: null,
  defaultComponent: Button,
  isGroup: false,
  size: null,
  disabled: false,
  withConfirmation: false,
  className: null
};
var Actions = function Actions(_ref) {
  var resource = _ref.resource,
    actions = _ref.actions,
    value = _ref.value,
    onChange = _ref.onChange,
    size = _ref.size,
    onConfirmed = _ref.onConfirmed,
    defaultComponent = _ref.defaultComponent,
    isGroup = _ref.isGroup,
    parentDisabled = _ref.disabled,
    withConfirmation = _ref.withConfirmation,
    className = _ref.className;
  var actionsComponents = useActionsComponentsManager();
  var disabled = value === null || value.length === 0;
  var finalActions = useMemo(function () {
    return (actions || []).filter(function (action) {
      return action !== null;
    }).map(function (action) {
      var _ref2 = action || {},
        _ref2$multiple = _ref2.multiple,
        multiple = _ref2$multiple === void 0 ? false : _ref2$multiple,
        _ref2$global = _ref2.global,
        global = _ref2$global === void 0 ? false : _ref2$global;
      var enabled = multiple ? value !== null && value.length > 0 : value !== null && value.length === 1;
      var finalDisabled = !global && (parentDisabled || disabled || !enabled);
      return _objectSpread(_objectSpread({}, action), {}, {
        disabled: finalDisabled,
        outline: finalDisabled
      });
    }, [actions]);
  }, [disabled, value, actions, parentDisabled]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([_defineProperty(_defineProperty({
      'd-flex': !isGroup,
      'btn-group': isGroup
    }, "btn-group-".concat(size), isGroup && size !== null), className, className !== null)])
  }, finalActions.map(function (action, idx) {
    var _ref4 = action || {},
      _ref4$id = _ref4.id,
      id = _ref4$id === void 0 ? null : _ref4$id,
      _ref4$component = _ref4.component,
      component = _ref4$component === void 0 ? null : _ref4$component,
      _ref4$multiple = _ref4.multiple,
      multiple = _ref4$multiple === void 0 ? false : _ref4$multiple,
      _ref4$withConfirmatio = _ref4.withConfirmation,
      actionConfirmation = _ref4$withConfirmatio === void 0 ? false : _ref4$withConfirmatio,
      otherProps = _objectWithoutProperties(_ref4, _excluded);
    var actionComponent = actionsComponents.getComponent(component);
    var hasActionComponent = actionComponent !== null;
    var Component = actionComponent || defaultComponent;
    var _ref5 = value || [],
      _ref6 = _slicedToArray(_ref5, 1),
      _ref6$ = _ref6[0],
      firstValue = _ref6$ === void 0 ? null : _ref6$;
    var finalValue = !multiple && firstValue !== null ? firstValue : value;
    return Component !== null ? /*#__PURE__*/React.createElement(Component, Object.assign({
      id: id,
      key: "action-".concat(id, "-").concat(idx + 1),
      className: !isGroup ? 'me-2' : null,
      iconPosition: "right",
      value: finalValue,
      size: size,
      multiple: multiple,
      resource: resource
    }, hasActionComponent ? {
      onChange: onChange,
      onConfirmed: onConfirmed,
      withConfirmation: actionConfirmation || withConfirmation
    } : null, otherProps)) : null;
  }));
};
Actions.propTypes = propTypes;
Actions.defaultProps = defaultProps;

export { Actions as default };
